export enum SeriesType {
    CDI = 'CDI',
    RESULT = 'RESULT',
    FIXED = 'FIXED',
    CDI_PLUS = 'CDI_PLUS'
}
